import { SvgIcon } from '@mui/material';

export function CheckIcon() {
  return (
    <SvgIcon width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path d="M8.70833 16.0418C8.43333 16.0418 8.25 15.9502 8.06667 15.7668L4.4 12.1002C4.03333 11.7335 4.03333 11.1835 4.4 10.8168C4.76667 10.4502 5.31667 10.4502 5.68333 10.8168L8.70833 13.8418L16.3167 6.2335C16.6833 5.86683 17.2333 5.86683 17.6 6.2335C17.9667 6.60016 17.9667 7.15016 17.6 7.51682L9.35 15.7668C9.16667 15.9502 8.98333 16.0418 8.70833 16.0418Z" />
    </SvgIcon>
  );
}
